import { useCart } from "./cart";

export function CartButton({ onClick }: { onClick: () => void }) {
  const { count } = useCart();
  return (
    <button
      type="button"
      className="cart-button"
      onClick={onClick}
      aria-label={count === 0 ? "Cart, empty" : `Cart, ${count} item${count === 1 ? "" : "s"}`}
    >
      <span aria-hidden="true">🛒</span>
      {count > 0 && <span className="cart-badge">{count}</span>}
    </button>
  );
}
